module["exports"] = [
  "Fiesta",
  "Focus",
  "Taurus",
  "Mustang",
  "Explorer",
  "Expedition",
  "F-150",
  "Model T",
  "Ranchero",
  "Volt",
  "Cruze",
  "Malibu",
  "Impala",
  "Camaro",
  "Corvette",
  "Colorado",
  "Silverado",
  "El Camino",
  "CTS",
  "XTS",
  "ATS",
  "Escalade",
  "Alpine",
  "Charger",
  "LeBaron",
  "PT Cruiser",
  "Challenger",
  "Durango",
  "Grand Caravan",
  "Wrangler",
  "Grand Cherokee",
  "Roadster",
  "Model S",
  "Model 3",
  "Camry",
  "Prius",
  "Land Cruiser",
  "Accord",
  "Civic",
  "Element",
  "Sentra",
  "Altima",
  "A8",
  "A4",
  "Beetle",
  "Jetta",
  "Golf",
  "911",
  "Spyder",
  "Countach",
  "Mercielago",
  "Aventador",
  "1",
  "2",
  "Fortwo",
  "V90",
  "XC90",
  "CX-9",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/vehicle/model.js
// module id = 2664
// module chunks = 1610